import React from 'react';
import { Button } from '@mui/material';
import {
  BRAND_ACCENT,
  BRAND_ACCENT_HOVER,
  BRAND_PRIMARY,
  BRAND_PRIMARY_HOVER_LIGHT,
} from './brandTokens';

/**
 * Brand outlined button (green border). Use tone="accent" for lime border.
 */
const BrandOutlinedButton = React.forwardRef(function BrandOutlinedButton(
  { tone = 'primary', sx, variant = 'outlined', ...props },
  ref
) {
  const baseSx =
    tone === 'accent'
      ? {
          borderColor: BRAND_ACCENT,
          color: BRAND_ACCENT,
          '&:hover': {
            borderColor: BRAND_ACCENT_HOVER,
            color: BRAND_ACCENT_HOVER,
            backgroundColor: 'rgba(134, 194, 50, 0.06)',
          },
        }
      : {
          borderColor: BRAND_PRIMARY,
          color: BRAND_PRIMARY,
          '&:hover': {
            borderColor: BRAND_PRIMARY_HOVER_LIGHT,
            color: BRAND_PRIMARY_HOVER_LIGHT,
            backgroundColor: 'rgba(97, 137, 47, 0.04)',
          },
        };

  return <Button ref={ref} variant={variant} sx={[baseSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} {...props} />;
});

export default BrandOutlinedButton;
